export default __webpack_public_path__ + "bd557dc6ec65c444819a6c62fadb6141.png";